import "../../../node_modules/underscore/modules/index-default.js";
import "../../../node_modules/underscore/modules/_setup.js";
import "../../../node_modules/underscore/modules/isFunction.js";
import "../../../node_modules/underscore/modules/_stringTagBug.js";
import "../../../node_modules/underscore/modules/isArguments.js";
import "../../../node_modules/underscore/modules/underscore.js";
import "../../../node_modules/underscore/modules/isMap.js";
import "../../../node_modules/underscore/modules/isWeakMap.js";
import "../../../node_modules/underscore/modules/isSet.js";
import "../../../node_modules/underscore/modules/toPath.js";
import "../../../node_modules/underscore/modules/iteratee.js";
import "../../../node_modules/underscore/modules/escape.js";
import "../../../node_modules/underscore/modules/unescape.js";
import "../../../node_modules/underscore/modules/templateSettings.js";
import "../../../node_modules/underscore/modules/partial.js";
import "../../../node_modules/underscore/modules/bind.js";
import "../../../node_modules/underscore/modules/bindAll.js";
import "../../../node_modules/underscore/modules/delay.js";
import "../../../node_modules/underscore/modules/defer.js";
import e from "../../../node_modules/underscore/modules/throttle.js";
import "../../../node_modules/underscore/modules/once.js";
import "../../../node_modules/underscore/modules/invoke.js";
import "../../../node_modules/underscore/modules/pick.js";
import "../../../node_modules/underscore/modules/omit.js";
import "../../../node_modules/underscore/modules/without.js";
import "../../../node_modules/underscore/modules/union.js";
import "../../../node_modules/underscore/modules/difference.js";
import "../../../node_modules/underscore/modules/zip.js";
import "../../../node_modules/underscore/modules/underscore-array-methods.js";
var o = function o(_o) {
    return e(_o, 66);
  },
  s = function s(e) {
    var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
      r = document.createElement(e);
    return Object.keys(o).forEach(function (e) {
      return r.setAttribute(e, o[e]);
    }), s && (r.innerHTML = s), r;
  },
  r = function r() {
    return document.scrollingElement || document.documentElement;
  },
  d = function d(e, o) {
    if (o.root = o.root || document, !e) return null;
    for (; !function (e, o) {
      if (o.node) return e === o.node;
      var s = e.getAttribute ? e.getAttribute("class") : "";
      return !!(!o.className || s && s.match(o.className)) && (!o.tagName || !!e.tagName && e.tagName.toLowerCase() === o.tagName.toLowerCase());
    }(e, o);) if ((e = e.parentNode) === o.root || !e || e === document) return null;
    return e;
  };
export { d as closest, s as createElement, r as getScrollNode, o as throttledResize };